export const getOptionLabel = (value, options, fallback = "—") => {
  if (!value) return fallback;
  const match = (options || []).find(
    (option) => option.key === value || option.value === value,
  );
  return match?.value ?? match?.label ?? value ?? fallback;
};

export const getLabelList = (values, options, fallback = "—") => {
  if (!Array.isArray(values) || values.length === 0) return fallback;
  const map = new Map(
    (options || []).map((option) => [
      option?.key ?? option?.value ?? option,
      option?.value ?? option?.label ?? option,
    ]),
  );
  return values.map((value) => map.get(value) ?? value).join(", ");
};
